module.exports = __webpack_public_path__ + "media/images/pc/articles/recommend_01-148148a2057b818b9a5244cc55d4b2cd.webp";